import Vue from "vue";
import VueRouter from "vue-router";
import decode from "jwt-decode";
import store from "@/store";
import Home from "@/views/Home.vue";
import ExchangeRoute from "./exchange/exchangeRoute";
import ExpenseRoute from "./ExpenseRoute/expRoute";
import QaasRoute from "./QAAS Route";

// import branch from "../views/Newbranch.vue";

Vue.use(VueRouter);

function AccessRout() {
  return decode(store.getters.showRtoken);
}

function authentication(to, from, next) {
  try {
    store.dispatch("AutoLogin");

    if (store.getters.showToken) {
      let ogol = AccessRout().ogol;
      // console.log(ogol);
      // if (!ogol.length) {
      //   next();
      // } else {
      let isAccess = false;
      for (let index = 0; index < ogol.length; index++) {
        if (ogol[index] == to.meta.name) {
          isAccess = true;
          break;
        }
      }
      if (isAccess) next();
      else next("/noAccess");
      // }
    } else next("/login");
  } catch (error) {
    // console.log("Eorro-- ", error);
  }
}

function unAuthenticated(to, from, next) {
  store.dispatch("AutoLogin");
  if (!store.getters.isAuthenticated) next();
  else next("/home");
}

const DevRoute = [
  {
    path: "/NewCompany",
    name: "NewCompany",
    beforeEnter: (to, from, next) => {
      if (process.env.NODE_ENV !== "production") next();
      else next(from.path);
    },
    component: () => import("../views/NewCompany.vue"),
  },
];

const BranchRoute = [
  // front-end\src\views\Branches\wholesale.vue
  // Groups Route
  {
    path: "/groups",
    name: "groups",
    meta: { name: "User Role" },
    beforeEnter: authentication,
    component: () => import("@/views/Users/Groups.vue"),
  },
  // Users Route
  {
    path: "/AddUser",
    name: "AddUser",
    meta: { name: "User List" },
    beforeEnter: authentication,
    component: () => import("@/views/Users/AddUsser.vue"),
  },
  {
    path: "/wholesale",
    name: "wholesale",
    meta: { name: "Wholesale" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Sales/wholesale.vue"),
  },
  {
    path: "/retail",
    name: "Retail",
    meta: { name: "Retail" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Sales/retailShop"),
  },
  {
    path: "/clients",
    name: "clients",
    meta: { name: "Clients" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Sales/Clients"),
  },
  {
    path: "/newStock",
    name: "NewStock",
    meta: { name: "New Stock" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Stocks/newStock"),
  },
  {
    path: "/transfer",
    name: "Transfer",
    meta: { name: "Transfer" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Stocks/transfer"),
  },
  {
    path: "/arrivedstock",
    name: "arrived",
    meta: { name: "Arrived" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Stocks/Arrived"),
  },
  {
    path: "/cashflow",
    name: "cashflow",
    meta: { name: "Cash Flow" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Reports/cashFllow"),
  },
  {
    path: "/trailbalance",
    name: "trailbalance",
    meta: { name: "Trail Balance" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Reports/trailBalance"),
  },
  {
    path: "/balancesheet",
    name: "balancesheet",
    meta: { name: "Balance Sheet" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Reports/BalanceSheet"),
  },
  {
    path: "/sales",
    name: "SalesRep",
    meta: { name: "Sale Report" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Reports/sales"),
  },
  {
    path: "/income",
    name: "Income",
    meta: { name: "Income" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Reports/income"),
  },
  {
    path: "/debtors",
    name: "Debtors",
    meta: { name: "Debtors" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/Reports/debts"),
  },
  {
    path: "/properties",
    name: "Properties",
    meta: { name: "Properties" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/company/equipments"),
  },
  {
    path: "/cashtransfer",
    name: "cashtransfer",
    meta: { name: "Cash Transfer" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/company/CashTransfer"),
  },
  {
    path: "/cashDep",
    name: "cashDep",
    meta: { name: "Cash Dep" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/company/MoneyDeposite"),
  },
  {
    path: "/withdrowcash",
    name: "CashDraw",
    meta: { name: "Cash Draw" },
    beforeEnter: authentication,
    component: () => import("@/views/Branches/company/MoneyWithdraw"),
  },
];

const ProRoute = [
  ...ExchangeRoute(authentication),
  ...ExpenseRoute(authentication),
  ...QaasRoute(authentication),
  {
    path: "/newbranch",
    name: "branch",
    meta: { name: "New Branch" },
    beforeEnter: authentication,
    component: () => import("@/views/HQ/Newbranch.vue"),
  },
  {
    path: "/owners",
    name: "Owners",
    meta: { name: "Owners" },
    beforeEnter: authentication,
    component: () => import("@/views/HQ/Owners.vue"),
  },
  {
    path: "/owner/:CustomerID",
    name: "OwnerInfo",
    meta: { name: "Owners" },
    props: true,
    beforeEnter: authentication,
    component: () => import("@/views/HQ/OwnerInfo.vue"),
  },
  {
    path: "/home",
    name: "Home",
    meta: { name: "Home" },
    beforeEnter: authentication,
    component: () => import("@/views/AuthHome.vue"),
  },
  {
    path: "/deletetran",
    name: "deletetran",
    meta: { name: "Delete" },
    beforeEnter: authentication,
    component: () => import("@/views/HQ/deletetran.vue"),
  },
  // All Supplier Route
  {
    path: "/theway",
    name: "theway",
    meta: { name: "On The Way" },
    beforeEnter: authentication,
    component: () => import("@/views/HQ/onTheWay.vue"),
  },
  {
    path: "/supplier",
    name: "Supplier",
    meta: { name: "Supplier" },
    beforeEnter: authentication,
    component: () => import("@/views/HQ/supplier.vue"),
  },
  {
    path: "/othercost",
    name: "othercost",
    meta: { name: "Other Cost" },
    beforeEnter: authentication,
    component: () => import("@/views/HQ/OtherCost.vue"),
  },
  {
    path: "/RegItem",
    name: "RegItem",
    meta: { name: "Register Items" },
    beforeEnter: authentication,
    component: () => import("@/views/HQ/RegNewItem.vue"),
  },
  // {
  //   path: "/newInventory",
  //   name: "newInventory",
  //   meta: { name: "New Inventory" },
  //   beforeEnter: authentication,
  //   component: () => import("@/views/HQ/newInventory.vue")
  // }
];

const routes = [
  ...BranchRoute,
  ...ProRoute,
  ...DevRoute,
  {
    path: "/login",
    name: "Login",
    beforeEnter: unAuthenticated,
    component: () => import("../views/login.vue"),
  },
  {
    path: "/",
    name: "fronPage",
    beforeEnter: unAuthenticated,
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
